import React, { useState, useEffect, useRef } from 'react';
import './index.css';
import TopSearches from './topSearches';
import RightDrawer from './rightDrawer';
import SearchFields from './searchFields';
import SearchResults from './../result/index';
import { message } from "antd";
import * as com from "../../../../Common.js";

const SearchBox = (paramsFromRightDrawer) => {
    const [showResults, setShowResults] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useState(null);
    const [customerid, setCustomerid] = useState(null);
    const [historyParams, setHistoryParams] = useState(null);
    const [search, setSearch] = useState(false);
    const searchSourceRef = useRef('check_rates')

    // saveSearchHistory persists the current form body so it shows up under
    // "Recent searches". The backend tags it source=ppe to keep it separate from
    // the legacy Rates history. Best-effort: history is non-critical, so failures
    // are swallowed and never block the search.
    const saveSearchHistory = (body) => {
        fetch("/los/priceengine/addsearchhistory", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
            },
            body: JSON.stringify(body),
        }).catch(() => {});
    };

    const handleCheckRates = (body, source) => {
        searchSourceRef.current =
            source === 'history' || source === 'top_search' || source === 'check_rates'
                ? source
                : 'check_rates'
        setSearch(false);
        setTimeout(() => {
            setLoading(true);
            // 添加时间戳确保每次调用都有变化
            setSearchParams({...body, _timestamp: Date.now()});
            setCustomerid(localStorage.getItem("customerid"));
            setShowResults(true);
            // setSearch(true);
        }, 0);
        saveSearchHistory(body);
    };

    const handleApplyParams = (params) => {
        // `params` is the stored form body (full shape, incl. ppe*/nonQm). Because
        // we persist the body shape, restore is a plain re-run: pass it straight
        // to handleCheckRates and repopulate the form via historyParams — no lossy
        // re-mapping that would drop the new PPE fields.
        const body = {
            ...params,
            downPayment: params.purpose === "Purchase" && !["heloc", "secondMortgage"].includes(params.loanProgram)
                ? params.propertyValue - params.loanAmount
                : undefined,
        };
        setHistoryParams({ ...body, from: "history" });
        handleCheckRates(body, 'top_search');
    }

    const handleRefineSearch = (params) => {
        // console.log('refine search', params)
        setHistoryParams({...params, from: "result"});
    }

    const handleBackToResult = () => {
        setShowResults(true);
        setSearch(false);
    }

    useEffect(() => {
        // History applied from the right drawer. Like handleApplyParams, pass the
        // stored body straight through (no lossy reformat) so ppe*/nonQm survive.
        if(paramsFromRightDrawer.params.purpose) {
            setShowResults(false);
            const stored = paramsFromRightDrawer.params.parameters;
            const body = {
                ...stored,
                downPayment: stored.purpose === "Purchase" && !["heloc", "secondMortgage"].includes(stored.loanProgram)
                    ? stored.propertyValue - stored.loanAmount
                    : undefined,
            };
            setHistoryParams({ ...body, from: "history" });
            handleCheckRates(body, 'history');
        }
    },[paramsFromRightDrawer])

    const showTopSearches = sessionStorage.getItem("showTopSearches") !== "false";

    return <div className='search-box'>
        {!showResults && showTopSearches && <TopSearches onApplyParams={handleApplyParams} />}
        {!showResults && <SearchFields onCheckRates={handleCheckRates} historyParams={historyParams} onBackToResult={handleBackToResult}/>}
        {searchParams && <SearchResults 
            style={{display: showResults ? "block" : "none"}}
            searchParams={searchParams} 
            customerid={customerid}
            loading={loading}
            setLoading={setLoading}
            search={search}
            setChangeShowResults={() => setShowResults(false)}
            onRefineSearch={handleRefineSearch}
            searchSource={searchSourceRef.current}
        />}
    </div>;
};

export default SearchBox;
